import { useContext } from "react";
import { EventCreateEditContext } from "./EventCreateEditContext";

export const useEventCreateEditContext = () => {
  const context = useContext(EventCreateEditContext);
  if (!context) {
    throw new Error(
      "useEventCreateEditContext must be used within a EventCreateEditContextProvider",
    );
  }
  return context;
};
